import { BaseDOM } from "../base.dom";

export class Permissions extends BaseDOM<Permissions> {
    Name!: string;

    static mapFromJSON(json: any) {
        const p = new Permissions();

        p.Name = json.name;

        return p;
    }
}
